import React, { createContext, useContext } from 'react';
// @ts-ignore
const ForecastContext = createContext(undefined);
export const ForecastProvider = ({ forecast, children, }) => (React.createElement(ForecastContext.Provider, { value: forecast }, children));
export const useForecast = () => useContext(ForecastContext);
